const CLINIC_TZ = 'Asia/Kolkata';
const clinicDay = (d: Date) => d.toLocaleDateString('en-CA', { timeZone: CLINIC_TZ });

/**
 * Same rule as the server: a prescription can be changed only on the clinic day it was written
 * (later corrections are a new prescription, copied from it), and never by a doctor other than
 * the one who wrote it.
 */
export function canEditPrescription(
  rx: { doctor_id?: string | null; created_at?: string | null },
  user?: { doctor_id?: string | null } | null,
): boolean {
  if (user?.doctor_id && user.doctor_id !== rx.doctor_id) return false;
  if (!rx.created_at) return false;
  return clinicDay(new Date(rx.created_at)) === clinicDay(new Date());
}
